import { Observable } from "rxjs";
import { UserNotificationListResponse } from "@app/core/notifications/domain/user-notification-list-response";

export abstract class UserNotificationRepository {
  abstract getNotificationsResponse(
    token: string
  ): Observable<UserNotificationListResponse>;
  abstract getUnreadNotificationsQuantity(token: string): Observable<number>;
  abstract readNotification(id: number, token: string): Observable<void>;
  abstract deleteNotification(id: number, token: string): Observable<void>;
}
